import React, { FC, useEffect, useState } from "react"

import { LeftOutlined } from "@ant-design/icons"
import { Card, Descriptions, Empty, Flex, Skeleton, Space, UploadFile } from "antd"
import { useNavigate, useParams } from "react-router-dom"
import { uid } from "uid"

import classes from "@/_styles/cardById.module.scss"
import variables from "@/_styles/variables.module.scss"
import { ColorifiedButton } from "@/components/_Shared/Button/ColorifiedButton"
import { PicturesUpload } from "@/components/_Shared/PicturesUpload"

import { useQualityPassportByIdQuery } from "@/hook/Waybills/QualityPassports/useQualityPassportQuery"

import { paths } from "@/router/paths"

import { formatDate } from "@/utils/formatDate"
import { uploadFileConvert } from "@/utils/uploadFileConvert"


const QualityPassportById: FC = () => {

  const navigate = useNavigate()
  const { id } = useParams<{ id?: string }>()

  const [fileList, setFileList] = useState<UploadFile[]>([])
  const { data, isLoading, isError } = useQualityPassportByIdQuery(Number(id))

  useEffect(() => {
    if (data?.response?.scans) {
      const newPromises = data.response.scans.map(file => uploadFileConvert({
        url: file.content,
        name: file.name,
        uid: uid()
      }))
      Promise.all(newPromises).then(res => {
        setFileList(res)
      })
    }
  }, [data?.response.scans])

  const onBackHandler = () => {
    navigate(paths.qualityPassports)
  }

  if (isError) {
    return <Empty description="Данные паспорта качества не найдены"/>
  }


  return (
    <>
      <Skeleton loading={isLoading}>
        {data && (
          <div>
            <Card className={classes["card"]}>
              <Space direction="vertical" className={classes["wrapper"]}>
                <Descriptions
                  title={
                    <div className={classes["header"]}>
                      <Flex align="center" gap="20px">
                        <ColorifiedButton
                          themecolor="blue"
                          type="primary"
                          shape="circle"
                          size="small"
                          icon={<LeftOutlined/>}
                          onClick={onBackHandler}
                        />
                        <span>Паспорт качества</span>
                      </Flex>
                    </div>
                  }
                  layout="vertical"
                  column={3}
                  className={classes["descriptions"]}
                  labelStyle={{
                    fontWeight: 600,
                    color: variables.tableSubTitleColor,
                    marginBottom: "-30px"
                  }}
                  contentStyle={{
                    paddingBottom: "15px"
                  }}
                >
                  <Descriptions.Item label="Номер записи">
                    {data.response.id}
                  </Descriptions.Item>
                  <Descriptions.Item label="Номенклатура">
                    {data.response.name}
                  </Descriptions.Item>
                  <Descriptions.Item label="Базис">
                    {data.response.depot.name}
                  </Descriptions.Item>
                  <Descriptions.Item label="Дата добавления">
                    {formatDate(data.response.date)}
                  </Descriptions.Item>
                </Descriptions>
              </Space>
            </Card>
            <Card title="Сканы" className={classes["card"]}>
              <Space direction="vertical" className={classes["wrapper"]}>
                <PicturesUpload readonly fileList={fileList}/>
              </Space>
            </Card>
          </div>
        )}
      </Skeleton>
    </>
  )
}

export default QualityPassportById